import { Injectable, inject } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { environment } from '@src/environments/environment';
import { Observable, map } from 'rxjs';
import { ConsentTypeDto, UpdateConsentsRequestDto, UserConsentDto } from '../models/dto/consent-type.dto';
import { ConsentTypeEntity, UserConsentEntity } from '../models/entities/consent.entity';
import { AppType } from '@app/shared/enums';
import { CURRENT_APP } from '@app/configs/app.config';

@Injectable({ providedIn: 'root' })
export class ConsentService {
  private http = inject(HttpClient);
  private base = environment.apiUrl;

  /**
   * Pobierz dostępne typy zgód
   * @param lang - język (pl, en) - domyślnie pl
   * @param requiredOnly - czy pobierać tylko wymagane zgody
   * @param app - typ aplikacji - domyślnie z environment.currentApp
   */
  getConsentTypes(lang = 'pl', requiredOnly = false, app: AppType = CURRENT_APP): Observable<ConsentTypeEntity[]> {
    let params = new HttpParams();
    if (lang) params = params.set('lang', lang);
    if (requiredOnly) params = params.set('requiredOnly', 'true');
    if (app) params = params.set('app', app);
    
    return this.http.get<ConsentTypeDto[]>(`${this.base}/consents/types`, { params }).pipe(
      map(list => list
        .sort((a, b) => a.order - b.order)
        .map(dto => new ConsentTypeEntity(dto))
      )
    );
  }

  getUserConsents(): Observable<UserConsentEntity[]> {
    return this.http.get<UserConsentDto[]>(`${this.base}/consents`).pipe(
      map(list => list.map(dto => new UserConsentEntity(dto)))
    );
  }

  updateConsents(req: UpdateConsentsRequestDto): Observable<{ message: string }>
  {
    return this.http.put<{ message: string }>(`${this.base}/consents`, req);
  }
}
